import { render, staticRenderFns } from "./NowPlaying.vue?vue&type=template&id=156cae64&scoped=true&"
import script from "./NowPlaying.vue?vue&type=script&lang=js&"
export * from "./NowPlaying.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/now-playing.scss?vue&type=style&index=0&id=156cae64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cae64",
  null
  
)

export default component.exports